import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'imobiliare-nivelul-1',
  meta: {
    siteTitle: 'Căruța cu bani - curs de investiții imobiliare nivelul 1',
    ogSiteName: 'Căruța Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/curs-imobiliare/',
    ogImage: 'https://carutacubani.ro/cursuri/curs-imobiliare/assets/images/imobiliare-nivel-2/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
